package one.healthium.healthKit.di

import org.koin.core.module.dsl.singleOf
import one.healthium.healthKit.ui.ConnectBannerHelper
import org.koin.dsl.module

val healthKitModule = module {
    includes(healthKitPlatformModule())
}


